import React , { useEffect, useState } from "react";
import { Button, Tooltip, Modal, Table , Row , Col, InputNumber, message, Radio} from "antd";
import './seat-price.style.scss';
import moment from 'moment';
import { loadingAction } from './../../actions/loading-actions';
import { useDispatch } from "react-redux";
import {
    updateScheduleTripFare
} from './../edit-fare-component/edit-fare.module';
import { checkActionAllowed, isValid, isValidArray } from "../../utils/utilities";
import { ACTION_TO_EDIT_FARE_FROM_AGENT_PORTAL } from "../../utils/constant";
import {
    ArrowDownOutlined,
    CopyOutlined,
    PlusOutlined,
    MinusOutlined
   } from '@ant-design/icons';
import { OriginDestionationFilter } from "../common-components/origin-destination-filter/origin-destination-filter.component";
import { getOriginsDestinations } from './seat-price.module';
import { getViacitiesDetails } from "../../actions/admin.action";
import { roundNumber } from "../../utils/math.utils";

const getSeatNumbers=(seats)=>{
    let text=null , array = [] , placeholder = null;
    seats.forEach((row)=>{
        if(isValid(text)){
            text=text +","+ row.seatNumber;
        }else{
            text= row.seatNumber;
        }
        if(!isValid(placeholder)){
            placeholder=row.fare;
        }else{
            if(placeholder !== row.fare){
                placeholder = "Multiple"
            }
        }
        array.push(row.seatNumber);
    })
    return {text,array,placeholder};
}

export const SeatPriceComponent = (props) => {

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [routes, setRoutes] = useState([]);
    const [seatNumbersString , setSeatNumbers] = useState(null);
    const [seatNumbersArray , setSeatNumbersArray] = useState(null);
    const [placeHolderTxt , setPlaceHolderTxt] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const [btnType, setBtnType] = useState(null);
    const [value, setValue] = useState(0);
    const [fareUpdateType, setFareUpdateType] = useState('amount');

    const [filteredRoutes, setFilteredRoutes] = useState([]);
    const [origins, setOrigins] = useState([]);
    const [destinations, setDestinations] = useState([]);
    const [originsFiltered, setOriginsFiltered] = useState(['all']);
    const [destinationsFiltered, setDestinationsFiltered] = useState(['all']);

    const {
        travelDate,
        tripStartDate,
        scheduleId,
        description,
        selectedSeats,
        bus,
        onSuccess,
        disableSetPrice
    } = props;

    useEffect(()=>{
        let{
            text,
            array,
            placeholder
        } = getSeatNumbers(selectedSeats);
        setSeatNumbers(text);
        setSeatNumbersArray(array);
        setPlaceHolderTxt(placeholder);
    },[selectedSeats]);

    const dispatch = useDispatch();
    const setloading=(bool)=>{
        dispatch(loadingAction(bool));
    }

    const showModal = () => {
      setIsModalVisible(true);
      setloading(true);
      getViacitiesDetails(scheduleId,moment(tripStartDate),(data)=>{
        let {filteredOrigins,filteredDestinations} = getOriginsDestinations(data);
        setOrigins(filteredOrigins);
        setDestinations(filteredDestinations);
        setRoutes(data);
        setFilteredRoutes(data);
        setloading(false);
        },
        ()=>{
            setloading(false);
        },0);
    };
  
    const onOriginChange =(values)=>{
        let formatedData = [];
        setOriginsFiltered(values);
        routes.forEach(element => {
            if((values.indexOf(element.origin) !== -1 || values.length === 0) && (destinationsFiltered.length === 0 || destinationsFiltered.indexOf(element.destination) !== -1)){
                formatedData.push(element);
            }
        });
        setFilteredRoutes(formatedData);
    }

    const onDestionationChange =(values)=>{
        let formatedData = [];
        setDestinationsFiltered(values);
        routes.forEach(element => {
            if((values.indexOf(element.destination) !== -1 || values.length === 0) && (originsFiltered.length === 0 || originsFiltered.indexOf(element.origin) !== -1)){
                formatedData.push(element);
            }
        });
        setFilteredRoutes(formatedData);
    }


    const routeColumns =[
        {
            dataIndex:'origin',
            key:'origin',
            render:(text,row)=>{
                return (
                    <div>{`${row.origin} - ${row.destination}`}</div>
                );
            }
        },
        {
            dataIndex:'fare',
            key:'fare',
            render:(text,row,rowIndex)=>{
                return(
                    <div>
                        <InputNumber 
                        placeholder={placeHolderTxt} 
                        value={row.value}
                        onChange={(value)=>{
                            let fareJsonObject=JSON.parse(row.fare_json);
                            if(!isValidArray(fareJsonObject)){
                                fareJsonObject = {}
                            }
                            seatNumbersArray.forEach(element => {
                                fareJsonObject[`SS_${element}`]=value;  
                            });
                            filteredRoutes[rowIndex].fare_json=JSON.stringify(fareJsonObject);
                            filteredRoutes[rowIndex].value=value;
                            filteredRoutes[rowIndex].is_fare_edited=true;
                            setFilteredRoutes([...filteredRoutes]);
                        }}/>
                    </div>
                 
                )
            }
        }
    ];

    
    const handleOk = () => {
      setIsModalVisible(false);
    };
  
    const handleCancel = () => {
      setIsModalVisible(false);
    };

    const getFare = (initialFare, addAmt) => {
        if(isValid(addAmt)){
            if(btnType === 'plus'){
                if (fareUpdateType === 'percentage') {
                    return roundNumber(initialFare + (initialFare * addAmt / 100));
                }
                return roundNumber(initialFare + addAmt);
            } else {
                if (fareUpdateType === 'percentage') {
                    return roundNumber(initialFare - (initialFare * addAmt / 100));
                }
                return roundNumber(initialFare - addAmt);
            }
        } else {
            return initialFare;
        }
    }

    const increORdecreFareBy = (amt) => {        
        for(let i = 0; i < filteredRoutes.length; i++) {
            let fareJsonObject = JSON.parse(filteredRoutes[i].fare_json);
            if(!isValidArray(fareJsonObject)){
                fareJsonObject = {};
            }            
            seatNumbersArray.forEach(element => {
                if(!isValid(fareJsonObject[`SS_${element}`])){
                    fareJsonObject[`SS_${element}`] = placeHolderTxt;
                }

                fareJsonObject[`SS_${element}`] = getFare(fareJsonObject[`SS_${element}`], amt);
            });
            filteredRoutes[i].fare_json = JSON.stringify(fareJsonObject);
            filteredRoutes[i].value = fareJsonObject[`SS_${seatNumbersArray[0]}`];
            filteredRoutes[i].is_fare_edited = true;
        }
        setFilteredRoutes([...filteredRoutes]);
        resetModal();
    }

    const resetModal = () => {
        setIsVisible(false);
        setValue(0);
    }

    if(checkActionAllowed(ACTION_TO_EDIT_FARE_FROM_AGENT_PORTAL)){
        return (
            <span>
                <Button onClick={showModal} disabled={disableSetPrice} className="seat-price-btn">Seat Price</Button>
                 <Modal title="Set Seat Price" 
                 maskClosable={false}
                 visible={isModalVisible} 
                 onOk={handleOk} 
                 onCancel={handleCancel}
                 footer={null}
                 >
                     <div className="seat-price-root">
                        <div className="fontWeightBold">{description}</div>
                        <div className="">Travel date : {travelDate}</div>
                        <div className="fontWeightBold">{seatNumbersString}</div>
                        <OriginDestionationFilter 
                            origins={origins}
                            destinations={destinations}
                            onOriginChange={onOriginChange}
                            onDestionationChange={onDestionationChange}
                            origin={originsFiltered}
                            destination={destinationsFiltered}
                        />
                        <Row className="buttons-block" gutter={[4,4]}>
                            <Col>
                                <Tooltip placement="topLeft" title={"Copy fare of 1st route to all routes"}>
                                    <Button
                                    className="margin-top-10 copy-fare-btn"
                                    onClick={()=>{
                                        let firstRow = filteredRoutes[0].fare_json;
                                        let firstValue = filteredRoutes[0].value;
                                        for (let index = 0; index < filteredRoutes.length; index++) {
                                            filteredRoutes[index].fare_json = firstRow;
                                            filteredRoutes[index].value = firstValue;
                                            filteredRoutes[index]["is_fare_edited"]=true;
                                        }
                                        setFilteredRoutes([...filteredRoutes]);
                                    }}>
                                        <CopyOutlined size={'large'}/> 
                                        <ArrowDownOutlined size={'large'} type="arrow-down" />
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col>
                                <Button
                                className="margin-top-10 plus-fare-btn"
                                onClick={() => {
                                    if(placeHolderTxt === 'Multiple'){
                                        message.error('Selected seats have different fares');
                                        return;
                                    }else{
                                        setBtnType('plus');
                                        setIsVisible(true);
                                    }
                                }}>
                                    <PlusOutlined size={'large'}/>
                                </Button>
                            </Col>
                            <Col>
                                <Tooltip placement="topLeft" title={"Clear seat-specific fare for selected seats"}>
                                    <Button
                                    className="margin-top-10 clear-fare-btn"
                                    onClick={()=>{
                                        let firstSeatGroupId = isValidArray(selectedSeats) && selectedSeats.length > 0
                                            ? selectedSeats[0].seatGroupId
                                            : null;                                            
                                        let updatedRoutes = filteredRoutes.map((route)=>{
                                            let fareJsonObject = JSON.parse(route.fare_json);
                                            if(!isValidArray(fareJsonObject)){
                                                fareJsonObject = {};
                                            }
                                            seatNumbersArray.forEach((element)=>{
                                                delete fareJsonObject[`SS_${element}`];
                                            });
                                            let newValue = route.fare;
                                            if(isValid(firstSeatGroupId) && isValid(fareJsonObject[firstSeatGroupId])){
                                                newValue = fareJsonObject[firstSeatGroupId];
                                            }
                                            return {
                                                ...route,
                                                fare_json: JSON.stringify(fareJsonObject),
                                                value: newValue,
                                                is_fare_edited: true
                                            };
                                        });
                                        setPlaceHolderTxt(0);
                                        setFilteredRoutes(updatedRoutes);
                                    }}>
                                        Clear Seat Fare
                                    </Button>
                                </Tooltip>
                            </Col>
                            <Col>
                                <Button
                                className="margin-top-10 minus-fare-btn"
                                onClick={() => {
                                    if(placeHolderTxt === 'Multiple'){
                                        message.error('Selected seats have different fares');
                                        return;
                                    }else{
                                        setBtnType('minus');
                                        setIsVisible(true);
                                    }
                                }}>
                                    <MinusOutlined size={'large'}/>
                                </Button>
                            </Col>
                        </Row>
                        <Table 
                            dataSource={filteredRoutes}
                            columns={routeColumns}
                            showHeader={false}
                            pagination={false}
                            scroll={{ y: 300,x: "max-content" }}
                            className="marginTop edit-fare-table"
                            tableLayout = "auto"
                        />
                        <Row gutter={[16,16]} justify="center" className="marginTop"> 
                            <Col>
                                <Button className="exit-btn"
                                onClick={handleCancel}
                                >Cancel</Button>
                            </Col>
                            <Col>
                                <Button className="" 
                                onClick={()=>{
                                    setloading(true);
                                    updateScheduleTripFare(
                                        filteredRoutes,
                                        [tripStartDate],
                                        scheduleId,
                                        bus,
                                        true,
                                        false,
                                        seatNumbersArray,
                                        false,
                                        false,
                                        (msg)=>{
                                            onSuccess(msg);
                                            setloading(false);
                                        },
                                        (emsg)=>{
                                            setloading(false);
                                            message.error(emsg);
                                        })
                                }}
                                >Update</Button>
                            </Col>
                        </Row>
                     </div>
                </Modal>
                <Modal
                    title={btnType === 'plus' ? "Increase all fares" : "Decrease all fares"}
                    visible={isVisible}
                    okText="Apply"
                    onOk={() => {
                        increORdecreFareBy(value);
                    }}
                    onCancel={resetModal}
                >
                    <Radio.Group
                        value={fareUpdateType}
                        onChange={(e) => setFareUpdateType(e.target.value)}
                        style={{ marginBottom: '16px' }}
                    >
                        <Radio value="amount">Amount</Radio>
                        <Radio value="percentage">Percentage</Radio>
                    </Radio.Group>
                    <br />
                    <InputNumber
                        value={value} 
                        onChange={(data) => {
                            setValue(data);
                        }}
                    />
                    {fareUpdateType === 'amount' ? " ₹" : " %"}
                </Modal>
            </span>
        )
    }else{
        return null;
    }
}